import React from "react";
import { withApollo } from "react-apollo";
import { Route, Switch, Redirect } from "react-router-dom";
import {
  Login,
  TagsList,
  ApplicationsList
} from "pages";
import { LANGUAGES_QUERY } from "graphql/queries";
import ApplicationContentManagement from "components/ApplicationContentManagement"
import Navigation from "components/Navigation"

const validCredentials =  () => {
  const token = localStorage.getItem("token");
  return !!token;
};

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={ props => {
      const shouldRedirect =  !validCredentials();
      return shouldRedirect ? (
        <Redirect
          to={{ pathname: "/login", state: {from: props.location} }}
        />
      ) : (
        <Component {...props} />
      );
    }}
  />
);

class App extends React.Component {
  render() {
    return (
      <div>
        <Switch>
          <Route exact path="/login" component={null} />
          <Route path="/applications/:application" component={Navigation}/>
          <Route path="/" component={Navigation}/>
        </Switch>
      <Switch>
        <Route exact path="/login" component={Login} />
        <PrivateRoute
            exact
            path="/tags"
            component={TagsList}
          />
        <PrivateRoute exact path="/applications" component={ApplicationsList} />
        <PrivateRoute path="/applications/:application" component={ApplicationContentManagement} />
        <Redirect to="/login" />
      </Switch>
      </div>
    );
  }
}

export default withApollo(App);



// WEBPACK FOOTER //
// ./src/components/App.js